export default __webpack_public_path__ + "static/media/1_portugal-image.2fdd9137.jpg";